export default {"src":"/_next/static/media/rcn.325a7b34.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};